import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { AddShoppingCart } from '@material-ui/icons';
import axios from 'axios';
import { Verification } from '../../components/dialogs/Verification';
import { useAuth } from '../../context/auth';
import { InformationTitle, Numbers, InformationWrapper } from '../../CampaignDetails/CampaignDetails.styles';
import { SectionName } from '../../Home/Home.styles';
import { MarginWrapper } from '../Dashboard.styles';
import {
    StyledContainer,
    Element,
    ElementDescription,
    ElementTitle,
    FlexWrapper,
    ElementName,
    GridWrapper,
    StyledItemIcon,
    Title,
    StyledLink,
    Description,
    Wrapper,
    Button
} from './NoDovePoints.styles';

export function NoDovePoints() {
    const { authToken, refreshDovePoints, user, wallet } = useAuth();
    const [verificationOpen, setVerificationOpen] = useState(false);
    const opacity = ['0.8', '0.6', '0.4', '0.2'];
    const getFreePoints = () => {
        axios.post(`/wallet/api/payments/wallets/get-free-points/`, {}, {headers: { DTOKEN: `${authToken}`}}).then(res => {
            refreshDovePoints();
        })
    }
    return (
        <MarginWrapper verified={user ? user.verifiedAccount : false}>
            <StyledContainer>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={8}>
                        <Title>Welcome on DoveMed Ads!</Title>
                        <Wrapper>
                            <StyledItemIcon backgroundColor="#2a71d41a" iconColor="#2A71D4">
                                <AddShoppingCart />
                            </StyledItemIcon>
                            <Description>
                                To start the campaign, please buy sufficient amount of DovePoints.<br/>
                                It will allow you to create and run campaign in desired timeframe.
                            </Description>
                        </Wrapper>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <InformationWrapper>
                            <InformationTitle>DovePoints Available</InformationTitle>
                            <Numbers>{wallet ? wallet.availablePoints : 0}</Numbers>
                            {(user && user.verifiedAccount) ?
                                <>
                                    {(wallet && wallet.hasWallet)
                                        ? <StyledLink to={`${process.env.REACT_APP_INTERNAL_URL}create-campaign/`}>Create campaign</StyledLink>
                                        : <StyledLink to={`${process.env.REACT_APP_INTERNAL_URL}dashboard/`} onClick={getFreePoints}>Collect your free points</StyledLink>
                                    }
                                </>
                                :
                                <Button onClick={() => setVerificationOpen(true)}>
                                    {(wallet && wallet.hasWallet) ? 'Create campaign' : 'Collect your free points'}
                                </Button>
                            }
                            <Verification open={verificationOpen} setOpen={setVerificationOpen} />
                        </InformationWrapper>
                    </Grid>
                </Grid>
                <SectionName>Create your first campaign to view statistics</SectionName>
                <GridWrapper>
                    {opacity.map((opacity, index) => (
                        <Element key={index} opacity={opacity}>
                            <ElementTitle></ElementTitle>
                            <FlexWrapper>
                                <ElementName></ElementName>
                                <ElementDescription></ElementDescription>
                            </FlexWrapper>
                            <FlexWrapper>
                                <ElementName></ElementName>
                                <ElementDescription></ElementDescription>
                            </FlexWrapper>
                            <FlexWrapper>
                                <ElementName></ElementName>
                                <ElementDescription></ElementDescription>
                            </FlexWrapper>
                        </Element>
                    ))}
                </GridWrapper>   
            </StyledContainer>
        </MarginWrapper>
    )
}
